/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdApplicationStoreInAppOneStoreOneStoreInAppBillingData } from './FxIdApplicationStoreInAppOneStoreOneStoreInAppBillingData';
import {
    instanceOfFxIdApplicationStoreInAppOneStoreOneStoreInAppBillingData,
    FxIdApplicationStoreInAppOneStoreOneStoreInAppBillingDataFromJSON,
    FxIdApplicationStoreInAppOneStoreOneStoreInAppBillingDataFromJSONTyped,
    FxIdApplicationStoreInAppOneStoreOneStoreInAppBillingDataToJSON,
} from './FxIdApplicationStoreInAppOneStoreOneStoreInAppBillingData';

/**
 * @type FxIdApplicationStoreInAppInAppValidationRequestOneStoreInAppBillingData
 * 
 * @export
 */
export type FxIdApplicationStoreInAppInAppValidationRequestOneStoreInAppBillingData = FxIdApplicationStoreInAppOneStoreOneStoreInAppBillingData;

export function FxIdApplicationStoreInAppInAppValidationRequestOneStoreInAppBillingDataFromJSON(json: any): FxIdApplicationStoreInAppInAppValidationRequestOneStoreInAppBillingData {
    return FxIdApplicationStoreInAppInAppValidationRequestOneStoreInAppBillingDataFromJSONTyped(json, false);
}

export function FxIdApplicationStoreInAppInAppValidationRequestOneStoreInAppBillingDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationStoreInAppInAppValidationRequestOneStoreInAppBillingData {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationStoreInAppOneStoreOneStoreInAppBillingData(json)) {
        return FxIdApplicationStoreInAppOneStoreOneStoreInAppBillingDataFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdApplicationStoreInAppInAppValidationRequestOneStoreInAppBillingDataToJSON(json: any): any {
    return FxIdApplicationStoreInAppInAppValidationRequestOneStoreInAppBillingDataToJSONTyped(json, false);
}

export function FxIdApplicationStoreInAppInAppValidationRequestOneStoreInAppBillingDataToJSONTyped(value?: FxIdApplicationStoreInAppInAppValidationRequestOneStoreInAppBillingData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdApplicationStoreInAppOneStoreOneStoreInAppBillingData(value)) {
        return FxIdApplicationStoreInAppOneStoreOneStoreInAppBillingDataToJSON(value as FxIdApplicationStoreInAppOneStoreOneStoreInAppBillingData);
    }

    return {};
}

